import React from 'react'

import { Dropdown } from '@fourthwall/components'

import { getRangeLabel } from '../../../utils/getRangeLabel'
import { AnalyticsSelectTool } from '../AnalyticsSelectTool/AnalyticsSelectTool'
import type { CompareDateRangeValue } from './AnalyticsCompareDateRangeSelect.types'

type AnalyticsCompareDateRangeSelectProps = {
  value: CompareDateRangeValue
  options: CompareDateRangeValue[]
  onSelect: (value: CompareDateRangeValue) => void
}

export const AnalyticsCompareDateRangeSelect = ({
  value,
  options,
  onSelect,
}: AnalyticsCompareDateRangeSelectProps) => {
  const handleSelect = (option: CompareDateRangeValue, close: () => void) => {
    onSelect(option)
    close()
  }

  return (
    <AnalyticsSelectTool
      label={`Compare: ${value.dates ? getRangeLabel(value.dates) : value.label}`}
      renderContent={({ close }) =>
        options.map((option) => (
          <Dropdown.Item
            active={value.value === option.value}
            key={option.value.toString()}
            label={option.label}
            onClick={() => handleSelect(option, close)}
          />
        ))
      }
    />
  )
}
